// eslint-disable-next-line import/no-unresolved
import { keyframes } from '@emotion/core';
import { Box, Flex } from '@modusign/design-system';
import * as CSS from 'csstype';
import { usePrevious } from 'react-use';

interface ProgressBarProps {
  currentProgressPercent: number;
  hideShadow: boolean;
  width: CSS.Property.Width;
}

const defaultProps = {
  hideShadow: false,
  width: '100%',
};

function ProgressBar({ currentProgressPercent, hideShadow, width }: ProgressBarProps) {
  const previousProgressPercent = usePrevious(currentProgressPercent) ?? 0;

  const progressBarAnimation = keyframes`
  0% {
    width: ${previousProgressPercent}%;
  }

  100% {
    width: ${currentProgressPercent}%;
  }
`;

  return (
    <Flex
      bg="lightGray200"
      borderRadius={100}
      boxShadow={hideShadow ? undefined : 'inset 0px 2px 5px rgba(0, 0, 0, 0.3)'}
      height={18}
      width={width}
    >
      <Box
        bg="amberYellow600"
        borderColor="amberYellow700"
        borderRadius={100}
        overflow="hidden"
        sx={{
          animationDuration: '0.5s',
          animationName: progressBarAnimation,
          animationTimingFunction: 'ease-out',
        }}
        width={`${currentProgressPercent}%`}
      />
    </Flex>
  );
}

ProgressBar.defaultProps = defaultProps;

export default ProgressBar;
